<div [formGroup]="form">
    <mat-form-field style="width:100%;">
        <mat-label *ngIf="show">{{label}}</mat-label>
        <input matInput [formControlName]="name" [placeholder]="label" [id]="'input-' + label" [readonly]="readonly" type="number" #input>
        <button mat-icon-button matSuffix *ngIf="suffix" (click)="suffix.context[suffix.action](suffix)">
            <mat-icon [svgIcon]="suffix.icon"></mat-icon>
        </button>
        <mat-error *ngIf="form && form.get(name).hasError('required')">
            {{label}} est <strong>requise</strong>
        </mat-error>
        <mat-error *ngIf="form && form.get(name).hasError('pattern')">
            {{label}} est <strong>incorrecte</strong>
        </mat-error>
        <!-- {{form.get(name).errors | json}} -->
    </mat-form-field>
</div>